export default {
  title: 'Timesheets',
  description: 'Hours worked from attendance, beside what was rostered. Correct a day, then approve the week to lock it for payroll.',
  approvedSomeSkipped: "Approved {done}; {skipped} couldn't be approved.",
  approvedOne: 'Approved {count} timesheet.',
  approvedOther: 'Approved {count} timesheets.',
  csvFileName: 'timesheets_{from}_to_{to}{suffix}.csv',
  csvAllSuffix: '_all',
  csvDailySuffix: '_daily',
  csvLayout: 'CSV layout',
  layoutSummary: 'Summary',
  layoutDaily: 'Daily',
  exportApproved: 'Export approved',
  exportAll: 'Export all',
  weekRange: '{from} to {to}',
  personOne: '{count} person',
  personOther: '{count} people',
  previousWeek: 'Previous week',
  thisWeek: 'This week',
  nextWeek: 'Next week',
  filterBySite: 'Filter by site',
  allSites: 'All sites',
  approveReady: 'Approve ready',
  approveReadyCount: 'Approve {count} ready',
  notFinished: "This week hasn't finished yet, so it can't be approved. Hours are still adding up.",
  noHoursTitle: 'No hours this week',
  noHoursMessage: 'Nobody has attendance, rostered shifts or adjustments in this period.',
  colEmployee: 'Employee',
  colWorked: 'Worked',
  colRostered: 'Rostered',
  colAdjusted: 'Adjusted',
  colTotal: 'Total',
  colDay: 'Day',
  colStart: 'Start',
  colEnd: 'End',
  previousDay: '{time} (previous day)',
  nextDay: '{time} (next day)',
  onSite: 'On site',
  approved: 'Approved',
  stillClockedIn: 'Still clocked in',
  open: 'Open',
  reopened: 'Timesheet reopened.',
  reopen: 'Reopen',
  adjust: 'Adjust',
  approvedName: 'Approved {name}.',
  approve: 'Approve',
  onLeave: 'on leave',
  adjustments: 'Adjustments',
  noAdjustments: 'No adjustments this week.',
  adjustmentLine: '<b>{hours}</b> on {date} · {reason}',
  adjustmentAdded: 'Adjustment added.',
  adjustTitle: "Adjust {name}'s hours",
  adjustDescription: 'Add or remove time on one day, with a reason that stays on their record.',
  day: 'Day',
  change: 'Change',
  removeTime: 'Remove time',
  addTime: 'Add time',
  hours: 'Hours',
  minutes: 'Minutes',
  reason: 'Reason',
  reasonHint: 'For example: unpaid lunch, worked off site, forgot to clock in.',
  addAdjustment: 'Add adjustment',
}
